import React from 'react';
import SimeraDashboard from '../../SimeraDashboard/SimeraDashboard';
import InternalDashboardPages from '../../../constants/InternalDashboardPages';

const SimeraDashboardScreenCompanies = () => {
  return <SimeraDashboard page={InternalDashboardPages.COMPANIES} />;
};

export default SimeraDashboardScreenCompanies;
